"use client";

import { useEffect } from "react";

import type { ProductVariantDetails } from "../types";

type ProductDetailsDebugLoggerProps = {
  product: ProductVariantDetails;
};

export default function ProductDetailsDebugLogger({
  product,
}: ProductDetailsDebugLoggerProps) {
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      return;
    }

    console.group("[Product details debug]");
    console.log("description from backend:", product.description);
    console.log("description metadata:", {
      type: typeof product.description,
      length: product.description?.length ?? 0,
      variantId: product.variantId,
      sku: product.sku,
      title: product.title,
    });
    console.log("full product payload:", product);
    console.groupEnd();
  }, [product]);

  return null;
}
